module["exports"] = [
  "com.au",
  "com",
  "net.au",
  "net",
  "org.au",
  "org"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_AU/internet/domain_suffix.js
// module id = 1477
// module chunks = 0